class WebSocketService {
    constructor() {
        this.subscribers = new Set();
        this.connect();
    }

    connect() {
        const token = localStorage.getItem('token');
        if (!token) {
            console.error('No token found for WebSocket connection');
            return;
        }

        const wsUrl = `wss://backend.slai.com/ws?token=${token}`;
        console.log('Connecting to WebSocket:', wsUrl);

        this.ws = new WebSocket(wsUrl);

        this.ws.onmessage = (event) => {
            console.log('WebSocket received message:', event.data);
            this.subscribers.forEach(callback => {
                try {
                    callback(event.data);
                } catch (error) {
                    console.error('Error in subscriber callback:', error);
                }
            });
        };

        this.ws.onerror = (event) => {
            console.error('WebSocket error:', event);
        };

        this.ws.onclose = () => {
            console.log('WebSocket connection closed');
            // Attempt to reconnect after a delay
            setTimeout(() => this.connect(), 5000);
        };
    }

    subscribe(callback) {
        console.log('New WebSocket subscriber added');
        this.subscribers.add(callback);
        return () => {
            console.log('WebSocket subscriber removed');
            this.subscribers.delete(callback);
        };
    }

    disconnect() {
        if (this.ws) {
            this.ws.close();
        }
    }
}

export const websocketService = new WebSocketService();
export default websocketService; 